export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0d0d18] border-t-2 border-purple-900/40">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://static.readdy.ai/image/ac6eabdb4cc8c584e68459ed2e8db63e/795a02a9e33dcc555b6c719772e4793b.png"
                alt="Roblox Secrets"
                className="h-10 w-10 object-contain"
              />
              <span
                className="font-black text-yellow-400 text-lg uppercase tracking-widest"
                style={{ textShadow: '0 0 10px rgba(250,204,21,0.5)' }}
              >
                Roblox Secrets
              </span>
            </div>
            <p className="text-gray-500 text-sm leading-relaxed mb-5">
              Discover the Unknown. Hidden worlds, secret rooms and unexpected discoveries inside Roblox.
            </p>
            {/* Social */}
            <div className="flex items-center gap-3">
              <a
                href="https://www.youtube.com/@ThekidsRobloxsecrets"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-purple-800/50 text-gray-400 hover:text-yellow-400 hover:border-yellow-400/50 transition-all duration-200"
                aria-label="YouTube"
              >
                <i className="ri-youtube-line text-lg"></i>
              </a>
              <a
                href="https://www.tiktok.com/@thekidsrobloxsecr"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-purple-800/50 text-gray-400 hover:text-yellow-400 hover:border-yellow-400/50 transition-all duration-200"
                aria-label="TikTok"
              >
                <i className="ri-tiktok-line text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-black text-sm uppercase tracking-widest mb-4">
              <a href="#quick-links">Quick Links</a>
            </h4>
            <ul className="flex flex-col gap-2.5">
              {[
                { label: 'Products', href: '#products' },
                { label: 'Membership', href: '#membership' },
                { label: 'Free Secret', href: '#lead-magnet' },
                { label: 'Videos', href: '#videos' },
                { label: 'About', href: '#about' },
              ].map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-gray-500 hover:text-yellow-400 text-sm transition-colors duration-200"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-white font-black text-sm uppercase tracking-widest mb-4">
              <a href="#legal">Legal</a>
            </h4>
            <ul className="flex flex-col gap-2.5">
              {[
                { label: 'Privacy Policy', href: '/privacy-policy' },
                { label: 'Terms of Service', href: '/terms' },
                { label: 'Refund Policy', href: '/refund-policy' },
                { label: 'Cookie Policy', href: '/cookie-policy' },
              ].map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-gray-500 hover:text-yellow-400 text-sm transition-colors duration-200"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-black text-sm uppercase tracking-widest mb-4">
              <a href="#contact">Contact Us</a>
            </h4>
            <div className="flex flex-col gap-3">
              <a
                href="mailto:thekids@robloxsecrets.pro"
                className="flex items-center gap-2 text-gray-500 hover:text-yellow-400 text-sm transition-colors duration-200"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-sm"></i>
                </div>
                thekids@robloxsecrets.pro
              </a>
              <a
                href="https://www.youtube.com/@ThekidsRobloxsecrets"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="flex items-center gap-2 text-gray-500 hover:text-yellow-400 text-sm transition-colors duration-200"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-youtube-line text-sm"></i>
                </div>
                YouTube Channel
              </a>
              <a
                href="https://www.tiktok.com/@thekidsrobloxsecr"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="flex items-center gap-2 text-gray-500 hover:text-yellow-400 text-sm transition-colors duration-200"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-tiktok-line text-sm"></i>
                </div>
                TikTok Page
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-10 pt-6 border-t border-purple-900/30 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-gray-600 text-sm text-center sm:text-left">
            &copy; {currentYear} Roblox Secrets. All rights reserved.
          </p>
          <p className="text-gray-700 text-xs text-center">
            Not affiliated with Roblox Corporation. All trademarks belong to their respective owners.
          </p>
        </div>
      </div>
    </footer>
  );
}
